import { fetchEquipments } from "./equipment-actions";
import { fetchStorages } from "./storage-actions";

export const fetchStorageAndEquipmentInitial = () => {
  return dispatch => {
    dispatch(fetchStorages()).then(() => dispatch(fetchEquipments()));
  };
};
